"use client"

import styled from "@emotion/styled"
import { layoutPadding, breakpoints } from "./theme/mediaQueries"

const StyledContainer = styled.div<{ $paddingMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${(p) => (p.$paddingMobile ? `0 ${layoutPadding.mobile}px` : 0)};

  @media (min-width: ${breakpoints.lg}px) {
    max-width: ${breakpoints.lg}px;
    padding: 0 ${layoutPadding.desktop}px;
    margin: 0 auto;
  }

  @media (min-width: ${breakpoints.xl}px) {
    max-width: ${breakpoints.xl}px;
    padding: 0 ${layoutPadding.desktopL}px;
  }

  @media (min-width: ${breakpoints.xxl}px) {
    max-width: ${breakpoints.xxl}px;
    padding: 0 ${layoutPadding.desktopXl}px;
  }
`

type Props = {
  children: React.ReactNode
  paddingMobile?: boolean
}

export default function Container({ children, paddingMobile }: Props) {
  return (
    <StyledContainer $paddingMobile={paddingMobile}>{children}</StyledContainer>
  )
}
